<!-- PARTIE SIMULATION DU BPF -->

<fieldset class="q-fieldset simulationBPF-fieldset mt-3">
  <legend>Simulation du BPF</legend>

  <div class="containerSimul d-flex align-items-baseline">
    
   
      <button (click)="openPageBilan()" class="btn btn-primary q-dark-primary-focus mt-3 mr-2"><i class="fas fa-eye mr-1"></i>Visualiser</button>
      <button (click)="downloadBilan()" class="btn btn-outline-light mt-3 mr-2 q-light-grey"><i class="fas fa-question-circle mr-1"></i>Aide BPF</button>

    
      <!--<span class="minWidthLab">Exercice du:</span>
      <div class="parentDate mr-2">
        <q-date [(ngValue)]="datePickerDebutInit" required></q-date>
      </div>

      <span>au:</span>
      <div class="parentDate">
        <q-date [(ngValue)]="datePickerFinInit" required></q-date>
      </div>-->
    </div>
  <!-- A VENIR PARTIE BPF ? -->
</fieldset>


  
    <!-- PARTIE TEST DES INCOHERENCES -->

    <fieldset class="q-fieldset incoherences-fieldset mt-4 mb-4">
      <legend>Test des incohérences</legend>
      <div *ngIf="isCloturable" class="row">
        <button (click)="clotureStage()" class="btn btn-primary q-dark-primary-focus ml-3" title="Clôturer le stage">Clôturer</button>
      </div>
      <div id="fixHeightScroll" class="table-responsive h-100 mt-2">
        <table *ngIf="lstTest && lstTest.length > 0" class="table table-bordered table-hover">
          <tbody>
            <tr *ngFor="let test of lstTest">
              <td [ngClass]="{'q-main': test.EtatRov == 0, 'q-warning': test.EtatRov == 1, 'q-danger': test.EtatRov == 2}" class="sizeColor noRightBorderInCell"></td>
              <td class="noRightBorderInCell">{{test.Titre}}</td>
              <td class="noRightBorderInCell">{{test.Etat}}</td>
              <td>{{test.Info}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </fieldset>

